import "./Icon_module.css";
const Icon_module = {
    icon: "icon__93a9a63dddc3d44a",
    clickable: "clickable__93a9a63dddc3d44a"
};
export { Icon_module as default };
